import { Cookie } from '@common-vue/util/src/modules/cookie';
import { cookies } from 'config';
/**
 * @param {string} zipCode
 * @return {boolean}
 */
const isValidZipCode = (zipCode) => /^\d{5}$/.test(zipCode);

function parseMISCGCsCookie() {
  // const storeConstants = [
  //   'USERPC',
  //   'BTZIPCODE',
  //   'BOPSPICKUPSTORE',
  //   'USERLL',
  // ];
  // const storeCookies = {};
  let userName = null;
  // let tokenExpiry = null;
  const MISCGCs = Cookie.get(cookies.miscGCs);

  if (MISCGCs) {
    const cookiesArray = MISCGCs.split('3_87_');
    cookiesArray.forEach((cookie) => {
      const cookieValue = cookie.split('1_92_')[1];
      // const [cookieName, cookieValue] = cookie.split('1_92_');
      if (cookie.includes('UserName')) {
        userName = cookieValue;
      }
      // if (cookie.includes('STExpiry')) {
      //   tokenExpiry = cookieValue;
      // }
      // if (storeConstants.includes(cookieName)) {
      //   storeCookies[cookieName] = cookieValue;
      // }
    });
  }

  return { userName };
  // return { userName, tokenExpiry, storeCookies };
}

export const getUserIds = () => {
  // Don't change the order of the calls of Cookie.get or it will fail the test
  const userGuid = Cookie.get(cookies.userGuid);
  const userId = Cookie.get(cookies.userId);
  const { userName } = parseMISCGCsCookie();
  const secureUserToken = Cookie.get(cookies.secureUserToken);
  const isSignedIn = Cookie.get(cookies.signedIn) === '1';

  return {
    userGuid,
    userId,
    userName,
    secureUserToken,
    isSignedIn,
  };
};

/**
 * @param {object} options
 * @param {string} options.guid
 * @param {string} options.id
 */
export const setUserCookies = ({ guid, id }) => {
  const thirthyDaysInMS = 2592000000;
  const expires = new Date(new Date().getTime() + thirthyDaysInMS);
  Cookie.set(cookies.userGuid, guid, false, { expires });
  Cookie.set(cookies.userId, id, false, { expires });
};

export const getSelectedStoreCookie = () => {
  const CSL = Cookie.get(cookies.csl);
  const bopsPickupInStore = Cookie.get(cookies.bopsPickupInStore, cookies.miscGCs);

  return CSL || bopsPickupInStore;
};

export const setSelectedStoreCookie = (locationNumber = '') => {
  Cookie.set(cookies.bopsPickupInStore, locationNumber, cookies.miscGCs);
};

export const getZipCodeCookie = () => Cookie.get(cookies.zipCode, cookies.miscGCs);

export const getBigTicketZipCookie = () => Cookie.get(cookies.bigTicketZipCode, cookies.miscGCs);

export const setZipCodeCookie = (zipCode = '') => {
  if (!isValidZipCode(zipCode)) {
    return;
  }

  Cookie.set(cookies.zipCode, zipCode, cookies.miscGCs);
};
